import styled from 'styled-components'
import { Box } from 'src/components'
import { motion } from 'framer-motion'

export const ContentButton = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 400px;
    }
`

export const ContentButtonGrow = styled(Box)`
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 130px;
    }
`

export const ContentNavigation = styled(motion(Box))`
    display: none;
    flex-direction: row;
    align-items: center;
    position: relative;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        display: none;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        min-width: 551.11px;
        display: flex;
        justify-content: space-between;
    }
`
